import { doPENDING_REQUEST_SET, PendingRequest, RequestPayload } from "../state/pending_request";
import { put, select } from "../../lib";

function* isSameRequestPending(requestType: string, payload: RequestPayload) {
  const pendingRequst: PendingRequest = yield select(
    (state) => state?.pendingRequest?.[requestType],
  );
  if (!pendingRequst) return false;

  let payloadNotMatchCount = 0;
  for (const requestPayload of Object.values(pendingRequst)) {
    for (const key in payload) {
      if (key === "requestId") continue;

      if (payload[key] !== requestPayload[key]) {
        payloadNotMatchCount++;
        break;
      }
    }
  }

  return payloadNotMatchCount !== Object.keys(pendingRequst).length;
}

export function* checkRequestPending(requestType: string, payload: object) {
  const pending = yield* isSameRequestPending(requestType, payload);
  if (pending) {
    return true;
  } else {
    yield put(doPENDING_REQUEST_SET({ requestType, payload }));
    return false;
  }
}
